// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/media/title_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 로그 및 알림 관리 - 사용자관리 공통 디자인 기준 */

.log-management-layout {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background: #f5f7fb;
}

.log-management-layout .log-management-content {
  flex: 1 1;
  min-width: 0;
  padding: 20px 28px 24px;
  box-sizing: border-box;
  color: #26354a;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}

.log-management-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.log-management-layout .log-management-header h2 {
  margin: 0 0 6px;
  padding: 0;
  border: 0;
  font-size: 21px;
  font-weight: 700;
  line-height: normal;
  color: #26354a;
}

.log-management-header p {
  margin: 0;
  color: #8190a2;
  font-size: 13px;
}

.log-management-layout .log-management-tabs {
  position: static;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0 18px;
  padding: 0;
  border: 0;
}

.log-management-tabs button {
  padding: 10px 18px;
  border: 1px solid #d8e1ec;
  border-radius: 8px;
  background: #f1f4f8;
  color: #68788b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.log-management-tabs button.active {
  background: #0e94f1;
  border-color: #0e94f1;
  color: #fff;
}

.log-management-tabs button:hover {
  filter: brightness(0.97);
}

.log-management-layout .log-management-panel {
  position: static;
  width: 100%;
  max-width: none;
  min-width: 0;
  padding: 22px;
  box-sizing: border-box;
  background: #fff;
  border: 0;
  border-radius: 10px;
  box-shadow: 0 2px 9px #1e375a10;
}

.log-management-layout .lm-section {
  position: static;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* 전역 main { display:flex } 충돌 해결 */
.log-management-layout main.log-management-content {
  display: block;
  height: auto;
}

.log-management-layout .log-management-page {
  display: block;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 사용자관리 기준: 제목 및 상단 영역 정렬 */
.log-management-layout .log-management-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 18px;
  padding: 0;
}

.log-management-layout .log-management-header h2 {
  margin: 0 0 6px;
  padding: 0;
  border: 0;
  font-size: 21px;
  font-weight: 700;
  line-height: normal;
  color: #26354a;
}

.log-management-layout .log-management-header p {
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: 400;
  color: #8190a2;
}

/* 사용자관리 기준: 탭 위치 및 크기 */
.log-management-layout .log-management-tabs {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 12px 0 18px;
}

.log-management-layout .log-management-tabs button {
  width: auto;
  height: auto;
  margin: 0;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  border-radius: 8px;
}

/* 사용자관리 기준: 카드 크기 */
.log-management-layout .log-management-panel {
  padding: 22px;
  border-radius: 10px;
}

/* 사용자관리 기준: 제목 및 상단 영역 정렬 */
.log-management-layout .log-management-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 18px;
  padding: 0;
}

.log-management-layout .log-management-header h2 {
  margin: 0 0 6px;
  padding: 0;
  border: 0;
  font-size: 21px;
  font-weight: 700;
  line-height: normal;
  color: #26354a;
}

.log-management-layout .log-management-header p {
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: 400;
  color: #8190a2;
}

/* 사용자관리 기준: 탭 위치 및 크기 */
.log-management-layout .log-management-tabs {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 12px 0 18px;
}

.log-management-layout .log-management-tabs button {
  width: auto;
  height: auto;
  margin: 0;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  border-radius: 8px;
}

/* 사용자관리 기준: 카드 크기 */
.log-management-layout .log-management-panel {
  padding: 22px;
  border-radius: 10px;
}

/* 사용자관리와 동일한 전체 건수 배지 */
.log-management-layout .log-management-total {
  display: inline-block;
  padding: 9px 13px;
  border-radius: 7px;
  background: #eaf3ff;
  color: #1671d8;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

/* 사용자관리 제목과 동일한 전역 h2 스타일 복원 */
.log-management-layout .log-management-header h2 {
  position: relative;
  padding: 0 0 15px;
  border: 0;
  border-bottom: 1px solid #9f9f9f;
  font-size: 21px;
  font-weight: 600;
  line-height: normal;
}

.log-management-layout .log-management-header h2::before {
  content: '';
  display: block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right bottom;
  width: 26px;
  height: 13px;
  position: absolute;
  right: 0;
  bottom: -7px;
}

/* 사용자관리 제목의 실제 브라우저 적용값 */
.log-management-layout .log-management-header h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LogPage.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,0EAAyE;EACzE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* 로그 및 알림 관리 - 사용자관리 공통 디자인 기준 */\n\n.log-management-layout {\n  display: flex;\n  width: 100%;\n  min-height: 100vh;\n  background: #f5f7fb;\n}\n\n.log-management-layout .log-management-content {\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 20px 28px 24px;\n  box-sizing: border-box;\n  color: #26354a;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n\n.log-management-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.log-management-layout .log-management-header h2 {\n  margin: 0 0 6px;\n  padding: 0;\n  border: 0;\n  font-size: 21px;\n  font-weight: 700;\n  line-height: normal;\n  color: #26354a;\n}\n\n.log-management-header p {\n  margin: 0;\n  color: #8190a2;\n  font-size: 13px;\n}\n\n.log-management-layout .log-management-tabs {\n  position: static;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 12px 0 18px;\n  padding: 0;\n  border: 0;\n}\n\n.log-management-tabs button {\n  padding: 10px 18px;\n  border: 1px solid #d8e1ec;\n  border-radius: 8px;\n  background: #f1f4f8;\n  color: #68788b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.log-management-tabs button.active {\n  background: #0e94f1;\n  border-color: #0e94f1;\n  color: #fff;\n}\n\n.log-management-tabs button:hover {\n  filter: brightness(0.97);\n}\n\n.log-management-layout .log-management-panel {\n  position: static;\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n  padding: 22px;\n  box-sizing: border-box;\n  background: #fff;\n  border: 0;\n  border-radius: 10px;\n  box-shadow: 0 2px 9px #1e375a10;\n}\n\n.log-management-layout .lm-section {\n  position: static;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n/* 전역 main { display:flex } 충돌 해결 */\n.log-management-layout main.log-management-content {\n  display: block;\n  height: auto;\n}\n\n.log-management-layout .log-management-page {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* 사용자관리 기준: 제목 및 상단 영역 정렬 */\n.log-management-layout .log-management-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 0 18px;\n  padding: 0;\n}\n\n.log-management-layout .log-management-header h2 {\n  margin: 0 0 6px;\n  padding: 0;\n  border: 0;\n  font-size: 21px;\n  font-weight: 700;\n  line-height: normal;\n  color: #26354a;\n}\n\n.log-management-layout .log-management-header p {\n  margin: 0;\n  padding: 0;\n  font-size: 13px;\n  font-weight: 400;\n  color: #8190a2;\n}\n\n/* 사용자관리 기준: 탭 위치 및 크기 */\n.log-management-layout .log-management-tabs {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin: 12px 0 18px;\n}\n\n.log-management-layout .log-management-tabs button {\n  width: auto;\n  height: auto;\n  margin: 0;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: normal;\n  border-radius: 8px;\n}\n\n/* 사용자관리 기준: 카드 크기 */\n.log-management-layout .log-management-panel {\n  padding: 22px;\n  border-radius: 10px;\n}\n\n/* 사용자관리 기준: 제목 및 상단 영역 정렬 */\n.log-management-layout .log-management-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 0 18px;\n  padding: 0;\n}\n\n.log-management-layout .log-management-header h2 {\n  margin: 0 0 6px;\n  padding: 0;\n  border: 0;\n  font-size: 21px;\n  font-weight: 700;\n  line-height: normal;\n  color: #26354a;\n}\n\n.log-management-layout .log-management-header p {\n  margin: 0;\n  padding: 0;\n  font-size: 13px;\n  font-weight: 400;\n  color: #8190a2;\n}\n\n/* 사용자관리 기준: 탭 위치 및 크기 */\n.log-management-layout .log-management-tabs {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin: 12px 0 18px;\n}\n\n.log-management-layout .log-management-tabs button {\n  width: auto;\n  height: auto;\n  margin: 0;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: normal;\n  border-radius: 8px;\n}\n\n/* 사용자관리 기준: 카드 크기 */\n.log-management-layout .log-management-panel {\n  padding: 22px;\n  border-radius: 10px;\n}\n\n/* 사용자관리와 동일한 전체 건수 배지 */\n.log-management-layout .log-management-total {\n  display: inline-block;\n  padding: 9px 13px;\n  border-radius: 7px;\n  background: #eaf3ff;\n  color: #1671d8;\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* 사용자관리 제목과 동일한 전역 h2 스타일 복원 */\n.log-management-layout .log-management-header h2 {\n  position: relative;\n  padding: 0 0 15px;\n  border: 0;\n  border-bottom: 1px solid #9f9f9f;\n  font-size: 21px;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.log-management-layout .log-management-header h2::before {\n  content: '';\n  display: block;\n  background: url('../../public/media/title_bg.png') no-repeat right bottom;\n  width: 26px;\n  height: 13px;\n  position: absolute;\n  right: 0;\n  bottom: -7px;\n}\n\n/* 사용자관리 제목의 실제 브라우저 적용값 */\n.log-management-layout .log-management-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
